var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.334 6.67V12.6667H4.66732V3.33333H8.66065V4.99333C8.66065 5.25855 8.76601 5.5129 8.95354 5.70044C9.14108 5.88798 9.39543 5.99333 9.66065 5.99333H12.6607V5.64533C12.6607 5.44733 12.5727 5.26 12.4213 5.13333L9.03865 2.30933C8.79865 2.10933 8.49665 2 8.18398 2H4.66732C4.3137 2 3.97456 2.14048 3.72451 2.39052C3.47446 2.64057 3.33398 2.97971 3.33398 3.33333V12.6667C3.33398 13.0203 3.47446 13.3594 3.72451 13.6095C3.97456 13.8595 4.3137 14 4.66732 14H11.334C11.6876 14 12.0267 13.8595 12.2768 13.6095C12.5268 13.3594 12.6673 13.0203 12.6673 12.6667V6.67H11.334Z",
    fill: "#5E6062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 8H6.00065C5.63246 8 5.33398 8.29848 5.33398 8.66667C5.33398 9.03486 5.63246 9.33333 6.00065 9.33333H10.0007C10.3688 9.33333 10.6673 9.03486 10.6673 8.66667C10.6673 8.29848 10.3688 8 10.0007 8Z",
    fill: "#5E6062"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 10H6.00065C5.63246 10 5.33398 10.2985 5.33398 10.6667C5.33398 11.0349 5.63246 11.3333 6.00065 11.3333H7.33398C7.70217 11.3333 8.00065 11.0349 8.00065 10.6667C8.00065 10.2985 7.70217 10 7.33398 10Z",
    fill: "#5E6062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ccf261cb6d2ddaa58b3cb9cd636260b4.svg";
export { ForwardRef as ReactComponent };